import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useMutation, useQuery } from "react-query";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { useTranslationEx } from "../../hooks/useTranslationEx";
import { EnhancedI18n } from "../../i18nEnhanced";
import AuthService from "../../services/authService";
import CategoryService from "../../services/categoryService";
import { getDefaultLanguage } from "../../toStdLanguages";
import { MenuResponse } from "../../types/category-menu";
import { AppInfo } from "../../utils/app-info";
import { useLangMenu } from "../../utils/conf";
import Utils from "../../utils/utils";
import MenuProduct from "../MenuProduct";
import PopularCities from "../PopularCities";
import { SvgPopularCities } from "../svg/SvgPopularCities";
import { CartBtn } from "./CartBtn";
import { useLogout } from "../../hooks/useLogout";
import { cdnImg, icAsset } from "../image/image-src";
const Header: React.FC = () => {
  const { t, i18n } = useTranslation();
  const { t2 } = useTranslationEx();
  const [lange, setLang] = useState(Utils.getCurrentLanguage());
  const location = useLocation();
  const navigate = useNavigate();
  const { isAuthenticated, setShowLoginModal } = useAuth();

  // const { data: unReadNumber } = useQuery<number>({
  //   queryKey: ["unReadInquiry"],
  //   queryFn: InquiryService.getInquiryUnRead,
  //   enabled: isAuthenticated,
  // });

  useEffect(() => {
    const storedLanguage = getDefaultLanguage();
    if (storedLanguage && storedLanguage !== i18n.language) {
      setLang(storedLanguage);
    }
  }, [i18n]);
  const { data: categoryData } = useQuery<MenuResponse | undefined>(
    ["locationCategories"],
    async () => CategoryService.getMenu(),
  );

  const categories = [
    {
      name: (
        <div className="flex items-center gap-2 pt-[7px] group-hover:text-primary">
          <SvgPopularCities />
          <span className="cursor-pointer text-base font-normal leading-[1.25rem]">
            {t("Popular Cities")}
          </span>
        </div>
      ),
      path: "/cities",
      menu: <PopularCities />,
    },
    {
      name: t("header.big-pass"),
      // path: "/pass",
      menu: <MenuProduct categories={categoryData?.pass} redirectUrl="/pass" />,
      // action: "handle",
      path: "/pass/introduction",
      action: "navigate",
    },
    // {
    //   name: t("header.ticket"),
    //   path: "/tickets",
    //   menu: (
    //     <MenuProduct categories={categoryData?.ticket} redirectUrl="/tickets" />
    //   ),
    //   action: "handle",
    // },
    // {
    //   name: t("header.tour"),
    //   path: "/guide-tours",

    //   menu: (
    //     <MenuProduct
    //       categories={categoryData?.tour}
    //       redirectUrl="/guide-tours"
    //     />
    //   ),
    //   action: "handle",
    // },
    // {
    //   name: t("header.musical"),
    //   path: "/musicals",
    //   menu: (
    //     <MenuProduct
    //       categories={categoryData?.musical}
    //       redirectUrl="/musicals"
    //     />
    //   ),
    //   action: "handle",
    // },
    // {
    //   name: t("header.e-sim"),
    //   path: "/e-sims",
    //   menu: (
    //     <MenuProduct categories={categoryData?.sim} redirectUrl="/e-sims" />
    //   ),
    //   action: "handle",
    // },
    {
      name: t("Customized Travel"),
      path: "/my-inquiry",
      submenu: [],
      action: "navigate",
    },
    {
      name: t("Hotel Inquiry"),
      path: "/hotel-inquiry",
      submenu: [],
      // action: "ex-navigate",
      action: "navigate",
    },
    {
      name: t("header.event"),
      path: "/events",
      submenu: [],
      action: "navigate",
    },
    {
      name: t("header.ticket-check"),
      path: "/ticket-check",
      submenu: [],
      action: "navigate",
    },
  ];

  const renderHeaderTop = () => (
    <div className="flex items-center justify-between bg-[#232323] px-10 py-2">
      <div className="flex gap-[1.5169rem]">
        <div className="flex items-center gap-2 text-white">
          <img
            className="h-[0.8125rem] w-[0.8125rem]"
            src={icAsset("../assets/images/icons/call.svg")}
            alt=""
          />
          <span className="header-text">{AppInfo.get("phone")}</span>
        </div>
        <div className="flex items-center gap-2 text-white">
          <img
            className="h-[0.8125rem] border-l border-[#FFF]/30 pl-[0.9206rem]"
            src={icAsset("../assets/images/icons/mail.svg")}
            alt=""
          />
          <span className="header-text">{AppInfo.get("email")}</span>
        </div>
      </div>
      <div className="flex items-center">
        {[
          {
            href: AppInfo.get("naver"),
            icon: "naver.svg",
            alt: "Naver Icon",
          },
          {
            href: AppInfo.get("kakao"),
            icon: "kakao.svg",
            alt: "KakaoTalk Icon",
          },
          {
            href: AppInfo.get("instagram"),
            icon: "camera.svg",
            alt: "Instagram Icon",
          },
        ]
          .filter((x) => x.href)
          .map((item, index) => (
            <React.Fragment key={item.icon}>
              {index > 0 && (
                <div className="h-[0.625rem] border-l border-[#FFF]/30" />
              )}
              <a
                href={item.href}
                target="_blank"
                rel="noopener noreferrer"
                className="pl-[0.875rem] pr-[0.9375rem]"
              >
                <img
                  className="h-[0.875rem] w-[0.875rem]"
                  src={icAsset(`../assets/images/icons/${item.icon}`)}
                  alt={item.alt}
                />
              </a>
            </React.Fragment>
          ))}
      </div>
    </div>
  );

  const renderCategories = () => (
    <div className="relative flex h-full items-center">
      <ul className="flex h-full items-center gap-10 xl:gap-16">
        {categories.map((category, index) => {
          const isActive =
            category.path === "/" + location.pathname.split("/")[1];
          return (
            <li
              key={index}
              className={`${
                category.name === t("header.home") ? "" : "relative"
              } group h-full content-center`}
            >
              <button
                type="button"
                onClick={() => handleCartegoryAction(category)}
                className={`h-6 cursor-pointer group-hover:text-primary ${
                  isActive ? "font-semibold text-[#007AFF]" : ""
                }`}
              >
                <span className="cursor-pointer text-base font-normal leading-[1.25rem] group-hover:text-primary">
                  {category.name}
                </span>
              </button>
              {category.menu}
            </li>
          );
        })}
      </ul>
    </div>
  );
  const handleCartegoryAction = (category: any) => {
    if (category.action === "navigate") {
      navigate(category.path);
    } else if (category.action === "ex-navigate") {
      window.location.href = category.path;
    }
  };

  const handleAction = (url: string) => {
    if (!isAuthenticated) {
      setShowLoginModal(true);
    } else {
      navigate(url);
    }
  };
  const profileMenu = [
    { title: t("My profile"), path: "/mypage/profile", action: "handle" },
    { title: t("My booking"), path: "/mypage/booking", action: "handle" },
    { title: t("Wishlist"), path: "/mypage/wishlist", action: "navigate" },
    { title: t("My inquiry"), path: "/my-inquiry", action: "handle" },
    { title: t("My cart"), path: "/shopping-cart", action: "navigate" },
  ];
  const handleMenuClick = (menu: (typeof profileMenu)[0]) => {
    if (menu.action === "navigate") {
      navigate(menu.path);
    } else if (menu.action === "handle") {
      if (!isAuthenticated) {
        setShowLoginModal(true);
      } else {
        navigate(menu.path);
      }
    }
  };

  const renderLogoutBtn = () => {
    if (!localStorage.getItem("token")) return null;
    return (
      <>
        <hr className="mx-3" />
        <li
          className={`h-12 cursor-pointer content-center p-3 text-[#FA5636] hover:bg-primary`}
          onClick={() => handleLogout()}
        >
          {t("Logout")}
        </li>
      </>
    );
  };
  const mutation = useLogout();

  const handleLogout = () => {
    mutation.mutate();
  };

  const renderMyProfileMenu = () => {
    return (
      <div className="absolute right-0 z-10 hidden w-[15rem] overflow-hidden rounded-[0.9375rem] border border-[#EBEBEB] bg-white shadow-custom1 group-hover:block">
        <ul>
          {profileMenu.map((menu, index) => (
            <li
              key={index}
              className={`h-12 cursor-pointer content-center p-3 hover:bg-primary`}
              onClick={() => handleMenuClick(menu)}
            >
              {t2(menu.title)}
            </li>
          ))}
          {renderLogoutBtn()}
        </ul>
      </div>
    );
  };
  const changeLanguage = (lng: string) => {
    setLang(lng);
    EnhancedI18n.changeLanguage(lng, true);
  };
  const languages = useLangMenu();
  const renderLangMenu = () => {
    if (languages.length <= 1) return null;
    return (
      <div className="absolute right-0 z-10 hidden w-[15rem] overflow-hidden rounded-[0.9375rem] border border-[#EBEBEB] bg-white shadow-custom1 group-hover:block">
        <ul>
          {languages.map((lang, index) => (
            <li
              key={index}
              className={`h-12 cursor-pointer content-center hover:bg-primary`}
              onClick={() => changeLanguage(lang.icon)}
            >
              <div className="flex gap-4 p-3">
                <img
                  className="h-6 w-6 rounded-full border border-[#DEDEDE]"
                  src={icAsset(`../assets/icons/${lang.icon}.svg`)}
                  alt={lang.icon}
                />
                <p className="text-[0.875rem] font-normal leading-[1.1919rem]">
                  {lang.label}
                </p>
              </div>
            </li>
          ))}
        </ul>
      </div>
    );
  };
  const renderUserIcons = () => {
    const activePath = (location.pathname ?? "").split("/")[1];

    return (
      <div className="flex items-center gap-5">
        {/* <button
          className="header-icon relative"
          onClick={() => navigate("/my-inquiry")}
        >
          <img
            className="mx-auto w-5 h-5"
            src={`../assets/images/icons/messages.svg`}
            alt="messages"
          />
          {isAuthenticated && unReadNumber && unReadNumber > 0 ? (
            <div className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center">
              {unReadNumber}
            </div>
          ) : null}
        </button> */}
        <CartBtn />
        <div className="group relative">
          <button
            className={
              "header-icon " + ("mypage" === activePath ? "active-header" : "")
            }
            onClick={() => handleAction("/mypage")}
          >
            <img
              className="mx-auto h-5 w-5"
              src={icAsset(`../assets/images/icons/profile.svg`)}
              alt="profile"
            />
          </button>
          {renderMyProfileMenu()}
        </div>
        <div className="group relative">
          <button className="header-icon">
            <img
              className="mx-auto h-11 w-11"
              src={icAsset(`../assets/icons/${lange}.svg`)}
              alt="ko"
            />
          </button>
          {renderLangMenu()}
        </div>
      </div>
    );
  };

  return (
    <>
      <header className="fixed left-0 top-0 z-50 hidden w-full lg:block">
        {renderHeaderTop()}
        <div className="flex h-[4rem] items-center justify-between border-b border-[#EAEEF3] bg-white px-5 xl:px-10">
          <Link to="/home">
            <img className="h-[48px]" src={AppInfo.get("logo")} alt="logo" />
          </Link>
          {renderCategories()}
          {renderUserIcons()}
        </div>
      </header>
      {/* <SidebarMenu handleCartegoryAction={handleCartegoryAction} /> */}
    </>
  );
};

export default Header;
